import React, { useState, useEffect, useRef } from "react";
import "./AboutUs.css";

/* ================= SVG ICONS ================= */
const BookOpenIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);

const TargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

const EyeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const HeartIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
  </svg>
);

const ClockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const ScaleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
    <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
    <path d="M7 21h10" />
    <path d="M12 3v18" />
    <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
  </svg>
);

const UsersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f96d2b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

/* ================= COMMITTEE MEMBERS DATA ================= */
const members = [
  {
    id: 1,
    name: "Tmt. S. Manjula Devi",
    position: "General Secretary",
    credentials: "B.Com Graduate",
    image: "../images/tt1.jpg",
    description:
      "General Secretary of the Anuk Charitable Trust and a B.Com graduate. She retired as an Assistant Revenue Officer at the Greater Chennai Corporation, bringing decades of administrative excellence and a lifelong dedication to community welfare.",
    experience: "35+ Years in Administration",
  },
  {
    id: 2,
    name: "Thiru K. P. Banuchandran",
    position: "Vice President",
    credentials: "M.A.",
    image: "../images/tt2.jpg",
    description:
      "Vice President of the Anuk Charitable Trust and former City Revenue Officer at Greater Chennai Corporation. He is also a Trustee of the Shree Dharma Sastha Ayyappan Yogam Public Charitable Trust (S2AY), renowned for his annual food distribution to the poor and elderly, and for sponsoring school fees for underprivileged children over many years.",
    experience: "Community Service Veteran",
  },
  {
    id: 3,
    name: "Thiru Soubramanien Shanmugam",
    position: "Vice President (France)",
    credentials: "International Coordinator",
    image: "../images/tt3.jpg",
    description:
      "Serving as Vice President from France, he leads our international outreach initiatives, connecting global donors with grassroots causes. His overseas coordination ensures sustained international support for our mission and expands the reach of our charitable programs beyond borders.",
    experience: "Global Outreach Leader",
  },
  {
    id: 4,
    name: "Thiru S. Djeabal",
    position: "Executive Committee Member",
    credentials: "Community Strategist",
    image: "../images/tt4.jpg",
    description:
      "A dedicated Executive Committee Member of the Anuk Charitable Trust, he plays a pivotal role in field operations and volunteer coordination. With professional experience at a leading multinational company in Singapore, he brings strong organizational skills, discipline, and a global perspective to the Trust's initiatives. His hands-on approach, leadership, and deep understanding of community needs help transform the Trust's vision into meaningful, lasting impact on the ground.",
    experience: "Field Operations Expert",
  },
  {
    id: 5,
    name: "Thiru G. Panchanathan",
    position: "Executive Committee Member",
    credentials: "Retired Record Clerk",
    image: "../images/tt5.jpg",
    description:
      "Executive Committee Member of the Anuk Charitable Trust who retired as a Record Clerk at the Greater Chennai Corporation. He is also an Executive Committee Member of the Sree Dharma Sastha Ayyappan Yogam Public Charitable Trust, contributing his organizational expertise to multiple charitable causes.",
    experience: "Dual Trust Service",
  },
  {
    id: 6,
    name: "Thiru C. Gurumoorthy",
    position: "Executive Committee Member",
    credentials: "Retired Tax Collector",
    image: "../images/tt6.jpg",
    description:
      "Executive Committee Member of the Anuk Charitable Trust who retired as a Tax Collector at the Greater Chennai Corporation. His financial diligence and civic experience ensure transparency and accountability in every initiative undertaken by the Trust.",
    experience: "Finance & Civic Affairs",
  },
  {
    id: 7,
    name: "Tmt. K. Kalyani",
    position: "Executive Committee Member",
    credentials: "Retired Section Manager",
    image: "../images/tt7.jpg",
    description:
      "Executive Committee Member of the Anuk Charitable Trust who retired as a Section Manager at the Greater Chennai Corporation. She also serves on the Executive Committee of the Sree Dharma Sastha Ayyappan Yogam Public Charitable Trust, championing women and children's welfare programs.",
    experience: "Women & Child Welfare",
  },
  {
    id: 8,
    name: "Thiru V. Nakkeeran",
    position: "Executive Committee Member",
    credentials: "B.Sc. Psy., MBA (HR)",
    image: "../images/tt8.jpg",
    description:
      "Executive Committee Member of the Anuk Charitable Trust, holding a B.Sc. in Psychology and an MBA in Human Resources. He currently serves as an Assessor at the Greater Chennai Corporation, bringing modern HR practices and psychological insight to volunteer development.",
    experience: "HR & Assessment Expert",
  },
  {
    id: 9,
    name: "Thiru D. Ganesan",
    position: "Executive Committee Member",
    credentials: "Retired Administrative Officer",
    image: "../images/tt9.jpg",
    description:
      "Executive Committee Member of the Anuk Charitable Trust who retired as an Administrative Officer at the Greater Chennai Corporation. He also serves on the Executive Committee of the Sree Dharma Sastha Ayyappan Yogam Public Charitable Trust, lending his administrative wisdom to charitable operations.",
    experience: "Administration Specialist",
  },
  
];

/* ================= ANIMATED COUNTER COMPONENT ================= */
const CountUp = ({ end, suffix, label }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let start = 0;
          const duration = 2000;
          const increment = end / (duration / 16);

          const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
              clearInterval(timer);
              setCount(end);
            } else {
              setCount(Math.floor(start));
            }
          }, 16);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (element) observer.observe(element);
    return () => {
      if (element) observer.unobserve(element);
    };
  }, [end]);

  return (
    <div className="milestone-card" ref={ref}>
      <span className="milestone-value">{count.toLocaleString()}{suffix}</span>
      <span className="milestone-label">{label}</span>
    </div>
  );
};

/* ================= MAIN COMPONENT ================= */
function AboutUs() {
  const [expandedMember, setExpandedMember] = useState(null);

  const toggleMember = (id) => {
    setExpandedMember(expandedMember === id ? null : id);
  };

  const values = [
    {
      title: "Compassion",
      desc: "We lead with empathy, treating every individual with warmth, respect, and genuine care.",
      icon: <HeartIcon />,
      img: "../images/core1.jpg",
    },
    {
      title: "Consistency",
      desc: "Real change requires steady effort. We show up reliably, day after day, for those who depend on us.",
      icon: <ClockIcon />,
      img: "../images/core2.jpg",
    },
    {
      title: "Dignity",
      desc: "We believe support should never come at the cost of self-respect. Every interaction honors human worth.",
      icon: <ShieldIcon />,
      img: "../images/core3.jpg",
    },
    {
      title: "Integrity",
      desc: "Transparency, accountability, and ethical practices guide every decision and every rupee we manage.",
      icon: <ScaleIcon />,
      img: "../images/core4.jpg",
    },
    {
      title: "Community Service",
      desc: "We grow together. Our work is rooted in local needs, driven by volunteers, and built for lasting impact.",
      icon: <UsersIcon />,
      img: "../images/core5.jpg",
    },
  ];

  const milestones = [
    { label: "Years of Service", value: 7, suffix: "+" },
    { label: "Lives Supported", value: 5000, suffix: "+" },
    { label: "Meals Distributed", value: 12000, suffix: "+" },
    { label: "Active Volunteers", value: 150, suffix: "+" },
  ];

  return (
    <div className="about-page-wrapper">

      {/* ================= HERO BANNER ================= */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('../images/bread.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title" style={{ textAlign: "center" }}>About Us</h1>
          <div className="hero-breadcrumb">
            <span>Home</span>
            <span className="arrow">➔</span>
            <span className="current">About us</span>
          </div>
        </div>
      </section>

      {/* ================= MAIN STORY SECTION ================= */}
      <section className="story-layout-section">
        <div className="layout-container">
          <div className="story-grid">
            <div className="story-left">
              <span className="sub-headline">Anuk Charitable Trust</span>
              <h2 className="main-headline">Transforming sacrifice into a sustainable force for good</h2>

              <p className="lead-paragraph">
                Born and raised in Puducherry, <strong>Mrs. Sophia Marie Josephen</strong> grew up in a humble household where kindness was lived daily. Witnessing the struggles of marginalized families, she carried a deep desire to make a tangible difference.
              </p>

              <p className="secondary-paragraph">
                When the COVID-19 pandemic struck, daily wage earners lost livelihoods, and the elderly were left vulnerable. Rather than wait, Mrs. Sophia took a bold step: <strong>she sold her own jewelry</strong> to buy groceries and medicines for those in desperate need.
              </p>

              <p className="secondary-paragraph">
                With the dedicated support and guidance of <strong>Mr. S. Suresh, Trustee of ANUK Charitable Trust</strong>, the mission expanded to reach more underprivileged families, elderly citizens, and students in need.
              </p>

              <p className="secondary-paragraph">
                In <strong>2022</strong>, the <strong>Anuk Charitable Trust</strong> was formally registered. Today, we continue to serve the elderly, underprivileged families, and students with absolute transparency and heart.
              </p>

              <div className="action-bar">
                <a href="tel:+918668106574" className="btn-primary">Discover More</a>
                <div className="contact-quick">
                  <div className="phone-icon-wrapper"><PhoneIcon /></div>
                  <div className="phone-text">
                    <span className="call-label">Get In Touch</span>
                    <span className="call-num">+91 86681 06574</span>
                  </div>
                </div>
              </div>

              <div className="founder-inline-box">
                <div className="founder-details">
                  <span className="founder-initials">SMJ</span>
                  <div>
                    <h4 className="founder-name">Mrs. Sophia Marie Josephen</h4>
                    <span className="founder-title">Founder & Managing Trustee</span>
                  </div>
                </div>
                <p className="founder-quote">
                  "True charity is not about giving what is left over. It is about sharing what matters, even when it costs you something."
                </p>
              </div>

              <div className="founder-inline-box">
                <div className="founder-details">
                  <span className="founder-initials">SS</span>
                  <div>
                    <h4 className="founder-name">Mr. S. Suresh</h4>
                    <span className="founder-title">Trustee, ANUK Charitable Trust</span>
                  </div>
                </div>
                <p className="founder-quote">
                  "Treasurer and Trustee of the Anuk Charitable Trust, an M.Com graduate who retired as an Accounts Officer at Greater Chennai Corporation. He is the Founder and President of Sree Dharma Sastha Ayyappan Yogam Public Charitable Trust (S2AY) and National General Secretary of the Manijanda Ayyappa Seva Sangham (MASS)."
                </p>
              </div>
            </div>

            <div className="story-right">
              <div className="image-gallery-wrapper">
                <div className="dots-pattern"></div>
                <img src="../images/mam.jpg" alt="Helping Hands" className="img-main" />
                <img src="../images/sir.jpg" alt="Community Care" className="img-sub" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MISSION & VISION ================= */}
      <section className="mission-vision-section">
        <div className="layout-container">
          <div className="mv-row">
            <div
              className="mv-img-box"
              style={{
                paddingTop: window.innerWidth <= 768 ? "100px" : "0",
                paddingBottom: window.innerWidth <= 768 ? "40px" : "0",
              }}
            >
              <img src="../images/mission1.jpg" alt="Our Mission" />
            </div>
            <div className="mv-text-box">
              <div className="icon-badge"><TargetIcon /></div>
              <h2 className="mv-headline">Our Mission</h2>
              <p className="mv-desc">
                To provide care, dignity, and essential support to the elderly, underprivileged communities, and students through consistent, transparent, and compassionate service. We focus on sustainable impact, ensuring that every contribution translates into real-world relief and opportunity.
              </p>
              <ul className="mv-bullet-list">
                <li>➔ Real-world relief for underprivileged families</li>
                <li>➔ Complete operational transparency</li>
                <li>➔ Consistent elderly & student welfare</li>
              </ul>
              <a href="/mission-details" className="hyperlink-btn">Read Full Mission Statement ➔</a>
            </div>
          </div>

          <div className="mv-row reverse">
            <div className="mv-img-box">
              <img src="../images/vision1.jpg" alt="Our Vision" />
            </div>
            <div className="mv-text-box">
              <div className="icon-badge"><EyeIcon /></div>
              <h2 className="mv-headline">Our Vision</h2>
              <p className="mv-desc">
                We are committed to building a hunger-free, dignified, and inclusive society where every individual receives care, support, and opportunities to thrive. Operating from a rented facility today, we provide free assistance to those in need and aspire to establish a permanent care center offering shelter, food, education, healthcare, and holistic support for long-term community development.
              </p>
              <ul className="mv-bullet-list">
                <li>➔ Hunger-Free & Empowered Communities</li>
                <li>➔ Free Care, Shelter & Essential Support</li>
                <li>➔ Education, Healthcare & Sustainable Upliftment</li>
              </ul>
              <a href="/vision-details" className="hyperlink-btn">Explore Our Vision Goals ➔</a>
            </div>
          </div>
        </div>
      </section>

      {/* ================= COMMITTEE MEMBERS SECTION - REDESIGNED ================= */}
      <section className="committee-section-v2">
        <div className="committee-container-v2">
          <div className="committee-header-v2">
            <span className="committee-subtitle-v2">Meet The Leadership</span>
            <h2 className="committee-title-v2">Our Committee Members</h2>
            <div className="committee-divider-v2">
              <span className="divider-line"></span>
              <span className="divider-icon">✦</span>
              <span className="divider-line"></span>
            </div>
            <p className="committee-description-v2">
              A distinguished team of retired public servants, professionals, and community leaders bringing decades of experience, integrity, and unwavering commitment to our mission.
            </p>
          </div>

          <div className="committee-grid-v2">
            {members.map((member) => (
              <div
                className={`member-card-v2 ${expandedMember === member.id ? "expanded" : ""}`}
                key={member.id}
              >
                <div className="member-card-inner">
                  <div className="member-image-wrapper-v2">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="member-image-v2"
                    />
                    <div className="member-experience-badge">
                      {member.experience}
                    </div>
                  </div>

                  <div className="member-info-v2">
                    <span className="member-position-badge">{member.position}</span>
                    <h3 className="member-name-v2">{member.name}</h3>
                    <p className="member-credentials">{member.credentials}</p>

                    <div className="member-divider-v2"></div>

                    <p className={`member-description ${expandedMember === member.id ? "show-full" : ""}`}>
                      {member.description}
                    </p>

                    <button
                      className="read-more-btn"
                      onClick={() => toggleMember(member.id)}
                      aria-label={`Read more about ${member.name}`}
                    >
                      {expandedMember === member.id ? "Show Less" : "Read More"}
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={expandedMember === member.id ? "rotate-up" : ""}
                      >
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </button>

                    <div className="member-socials-v2">
                      <a href="#" aria-label="Facebook">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                          <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                        </svg>
                      </a>
                      <a href="#" aria-label="Twitter">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                          <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
                        </svg>
                      </a>
                      <a href="#" aria-label="LinkedIn">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                          <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= CORE VALUES ================= */}
      <section className="values-section">
        <div className="layout-container">
          <div className="section-header center">
            <span className="sub-headline">Standards We Uphold</span>
            <h2 className="main-headline">Our Core Values</h2>
            <p className="subtitle-text">The unshakeable principles that guide every action we take and every rupee we manage.</p>
          </div>

          <div className="values-grid">
            {values.map((item, i) => (
              <div key={i} className="value-card">
                <div className="value-img-wrapper">
                  <img src={item.img} alt={item.title} className="value-img" />
                  <div className="value-icon-floating">{item.icon}</div>
                </div>
                <div className="value-content">
                  <h3 className="value-title">{item.title}</h3>
                  <p className="value-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= MILESTONES ================= */}
      <section className="milestones-section">
        <div className="layout-container">
          <div className="section-header center">
            <h2 className="main-headline">Our Impact So Far</h2>
            <p className="subtitle-text">Empowering lives through measurable and consistent acts of kindness.</p>
          </div>

          <div className="milestones-grid">
            {milestones.map((item, i) => (
              <CountUp key={i} end={item.value} suffix={item.suffix} label={item.label} />
            ))}
          </div>
          <p className="milestone-note">* Figures are approximate and updated quarterly based on our verified operational registries.</p>
        </div>
      </section>

      {/* ================= CTA FOOTER ================= */}
      <section className="about-footer-cta">
        <div className="layout-container center">
          <p className="cta-tagline">"Small Acts. Consistent Care. Lifelong Impact."</p>
          <h2 className="cta-headline">Join Us in Making a Difference</h2>
          <a href="/DonateNow" className="btn-primary large">Support Our Mission Today</a>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;